import { render } from "./SetupAssesor.vue?vue&type=template&id=7479da00"
import script from "./SetupAssesor.vue?vue&type=script&lang=js"
export * from "./SetupAssesor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__